<template>
	<div>
		<BarcodeReader ref="barcodeReader" @readed="readedBarcode" />
	</div>
</template>

<script>
import BarcodeReader from "@/components/BarcodeReader"
export default {
	name: "CovidVaccineCertification",
	components: {
		BarcodeReader
	},
	mounted() {
		this.$refs.barcodeReader.open()
	},
	methods: {
		readedBarcode(barcode) {
			console.log(barcode)
		}
	}
}
</script>
